import EditPerson from './EditPerson';

export default EditPerson;
